module.exports = __webpack_public_path__ + "static/media/auto.12ff7cc5.png";